import React from 'react';
import { RISK_TIERS } from '../../../utils/riskTier';

export default function CommunityReports() {
  return null;
}

// Temporarily hidden — scum reporting feature not yet available.
// eslint-disable-next-line no-unused-vars
function CommunityReportsFull({ tierKey, onReport, reports = [] }) {
  const tc = RISK_TIERS[tierKey] || RISK_TIERS.BASELINE;
  const hasReports = reports.length > 0;

  if (!hasReports) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
        padding: '12px 16px', borderRadius: 12,
        background: '#fff', border: '1px solid #ece7db', marginBottom: 16,
      }}>
        <span style={{ fontSize: 15, color: '#46505a' }}>No shoreline reports today.</span>
        <button
          onClick={onReport}
          style={{
            flexShrink: 0, padding: '6px 14px', borderRadius: 8,
            fontSize: 14, fontWeight: 600, cursor: 'pointer',
            background: 'none', border: '1px solid #dcd6c8', color: '#46505a',
            fontFamily: 'inherit',
          }}
        >
          Report what you see
        </button>
      </div>
    );
  }

  return (
    <div style={{ background: '#fff', borderRadius: 14, padding: 20, border: '1px solid #ece7db', marginBottom: 16 }}>
      <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: '.1em', textTransform: 'uppercase', color: '#6f6a5f', marginBottom: 14 }}>
        Community Reports
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {reports.map((r, i) => (
          <div key={i} style={{ padding: '10px 12px', borderRadius: 9, background: '#f8f7f4', fontSize: 15, color: '#374151', lineHeight: 1.6 }}>
            {r.text || r.description || JSON.stringify(r)}
          </div>
        ))}
      </div>
      <button
        onClick={onReport}
        style={{
          marginTop: 14, width: '100%', padding: '9px 0', borderRadius: 9,
          fontSize: 13, fontWeight: 600, cursor: 'pointer',
          background: tierKey !== 'BASELINE' ? tc.color : '#f8f7f4',
          color: tierKey !== 'BASELINE' ? '#fff' : '#475569',
          border: tierKey !== 'BASELINE' ? 'none' : '1px solid #e2e8f0',
          fontFamily: 'inherit',
        }}
      >
        Submit a report
      </button>
    </div>
  );
}
